import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 12,
  steps: [
    addColumns({
      table: 'messages',
      columns: [
        { name: 'source_url', type: 'string', isOptional: true },
        {
          name: 'source_type',
          type: 'string'
        }
      ]
    })
  ]
}
